import { GraphNodeTypes } from '../../../services/ducks/designerDuck/designerDuck';

export const triggerParser = (next, items, start) => {
  const newItems = {
    trigger: {
      id: 'trigger',
      type: GraphNodeTypes.TRIGGER,
      next: [start],
      data: {},
    },
    ...items,
  };

  return next(newItems, 'trigger');
};
